import { TypedNodeContext } from './context'

import type { TypedNode } from '@rehaje/core'
import type { FC, PropsWithChildren } from 'react'

export interface TypedNodeProviderProps {
  node: TypedNode
}

export const TypedNodeProvider: FC<
  PropsWithChildren<TypedNodeProviderProps>
> = ({ children, node }) => {
  return (
    <TypedNodeContext.Provider value={node}>
      {children}
    </TypedNodeContext.Provider>
  )
}
